import {
  Button,
  FormInput,
  FormRoot,
  FormSelect,
  FormTextarea,
  RHF,
  zodResolver,
} from "@devhop/ui";
import { SparklesIcon } from "lucide-react";
import type { z } from "zod";
import { CreateClassTypeSchema } from "@/modules/master/domain/contracts";
import { isDevMode } from "@/shared/lib/config";
import { getRandomMockData, mockClassTypes } from "../dev-mock-data";

const ClassTypeFormSchema = CreateClassTypeSchema;
export type ClassTypeFormValues = z.infer<typeof ClassTypeFormSchema>;

export function ClassTypeForm({
  initialValues,
  onSubmit,
  submitting,
}: {
  initialValues?: Partial<ClassTypeFormValues>;
  onSubmit: (values: ClassTypeFormValues) => void;
  submitting?: boolean;
}) {
  const methods = RHF.useForm<ClassTypeFormValues>({
    resolver: zodResolver(ClassTypeFormSchema),
    defaultValues: {
      name: initialValues?.name || "",
      description: initialValues?.description || "",
      status: initialValues?.status || "active",
    },
  });

  const handleAutoFill = () => {
    const mockData = getRandomMockData(mockClassTypes);
    methods.reset(mockData);
  };

  return (
    <FormRoot methods={methods} onSubmit={onSubmit} className="space-y-6">
      <div className="space-y-4">
        <FormInput
          name="name"
          label="ຊື່"
          placeholder="ປ້ອນຊື່ປະເພດຄລາດສ໌"
          required
        />

        <FormTextarea
          name="description"
          label="ຄຳອະທິບາຍ"
          placeholder="ປ້ອນຄຳອະທິບາຍ (ບໍ່ບັງຄັບ)"
          rows={3}
        />

        <FormSelect
          label="ສະຖານະ"
          name="status"
          options={[
            { value: "active", label: "ໃຊ້ງານ" },
            { value: "inactive", label: "ບໍ່ໃຊ້ງານ" },
          ]}
        />
      </div>

      <div className="flex justify-end gap-2 border-t pt-4">
        {isDevMode && (
          <Button
            type="button"
            variant="outline"
            onClick={handleAutoFill}
            disabled={submitting}
          >
            <SparklesIcon className="size-4" />
            Auto Fill
          </Button>
        )}
        <Button
          type="button"
          variant="outline"
          onClick={() => methods.reset()}
          disabled={submitting}
        >
          ລ້າງ
        </Button>
        <Button type="submit" disabled={submitting}>
          {submitting ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
        </Button>
      </div>
    </FormRoot>
  );
}
